<template>
    <svg :class="svgClass" aria-hidden="true" v-on="$listeners">
        <use :xlink:href="href" />
    </svg>
</template>

<script>
export default {
    name: 'SySvgIcon',
    props: {
        /**
         * 图标名
         */
        icon: {
            type: String,
            required: true
        },
        /**
         * 图标类名
         */
        iconClass: {
            type: String,
            default: ''
        }
    },
    computed: {
        /**
         * SvgClass计算值
         * @return {string}
         */
        svgClass() {
            if (this.iconClass) {
                return `svg-icon ${this.iconClass}`;
            }
            return 'svg-icon';
        },
        /**
         * Svg元素href计算值
         * @return {string}
         */
        href() {
            return `#${this.icon}`;
        }
    }
};
</script>

<style lang="scss" scoped>
.svg-icon {
    width: 1em;
    height: 1em;
    overflow: hidden;
    vertical-align: bottom;
    fill: currentColor;
}
</style>
